<template>
<!-- 售后服务-留言咨询 -->
    <div class="content">
        <form>
            <div class="message">
                <textarea name="留言"
                value=""
                placeholder="请输入您的内容（必填）"
                rows="10"
                cols="28"
                maxlength="300"
                v-model="desc"
                @input="descInput"></textarea>
                <span class="txtVal">{{ txtVal }}/300</span>
            </div>

            <p class="uploadPic">上传图片 <span>(最多三张) 选填</span></p>

            <div class="van-uploader">
                <div class="van-uploader__wrapper">
                    <!-- aa  -->
                    <div class="van-uploader__preview">
                        <div v-for="item in imageUrlList" :key="item.index" class="van-image van-uploader__preview-image">
                            <img :src="item" class="van-image__img" style="object-fit: cover;">
                            <van-icon class="van-uploader__preview-delete" @click="delete_img" name="cross" />
                        </div>
                    </div>
                    <div v-if="upload" @click="clickUpload" class="van-uploader__upload">
                        <van-icon class="van-icon van-icon-plus van-uploader__upload-icon" name="plus" />
                        <input multiple="multiple" accept="image/*" class="van-uploader__input" type="flie">
                    </div>
                </div>
            </div>
        </form>
        <button class="preserve" @click="submit">确认咨询</button>
    </div>
</template>

<script>
import Vue from 'vue';
import { Uploader } from 'vant';
import { Popup } from 'vant';
import { Toast } from 'vant';
import wx from 'weixin-js-sdk';
import { Icon } from 'vant';
import { Dialog } from 'vant';
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Uploader);

export default {
    data() {
        return {
            isIOS: '',  // ios
            isAndroid: '',  // 安卓

            txtVal: 0,  // 已输入文字字数
            desc: '',   // 留言内容
            show: false,    // 咨询完成的提示

            imageUrlList: [],   // 图片预览的数组

            suggestionimgs: [],

            upload: true,
        };
    },
    created() {
        this.isAndroidFun()
    },
    mounted() {
        this.axios.get('/weixin/wxJsSdkConfig',{
            params: {
                url : location.href.split('#')[0]
            }
        }).then((res)=>{
            wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: ['chooseImage','uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
        }),

        wx.ready(function() {
            wx.checkJsApi({
                jsApiList : [ 'openWXDeviceLib', 'closeWXDeviceLib','chooseImage','uploadImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success : function(res) {
                }
            });
            wx.error(function(res) {
                alert(res)
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });

            wx.invoke('openWXDeviceLib', {
                'connType' : 'lan'

            }, function(res) {
                //alert(JSON.stringify(res));
            });

		});
    },
    methods: {
        descInput() {
            this.txtVal = this.desc.length;
        },

        clickUpload() {
            let self = this;
            wx.chooseImage({
                count: 1, // 默认9
                sizeType: ['original', 'compressed'],
                sourceType: ['album', 'camera'],
                success: function (res) {
                    var localIds = res.localIds
                    for (var i = 0; i < localIds.length; i++) {
                        wx.getLocalImgData({
                            localId:res.localIds[i],
                            success: function (res){
                                var localData = res.localData;
                                if(self.isIOS) {    //ios
                                    localData = localData.replace('jgp', 'jpeg');
                                }
                                if(self.isAndroid) {    // 安卓
                                    localData = 'data:image/jpeg;base64,'+localData;
                                }
                                self.imageUrlList.push(localData)
                                if(self.imageUrlList.length == 3) {
                                    self.upload = false
                                }
                            }
                        })
                        wx.uploadImage({
                            localId: res.localIds[i],
                            isShowProgressTips: 1,
                            success: function (res) {
                                self.suggestionimgs.push(res.serverId)
                            }
                        });
                    }
                }
            });
        },

        // 判断ios还是安卓
        isAndroidFun() {
            var u = navigator.userAgent
            var app = navigator.appVersion
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if(isAndroid) {
                this.isAndroid = true;
            }else if(isiOS) {
                this.isIOS = true;
            }
        },

        // 确认留言咨询
        submit() {
            if(this.desc.length === 0) {
                Toast('请填写问题描述!');
                return false
            }

            let data = {
                suggestioncontent: this.desc,
                suggestionimgs: this.suggestionimgs
            }

            this.axios.post('/weixin/insertsuggestion',
            data)
            .then(res=>{
                Dialog.alert({
                    message: '咨询反馈完成,请等待管理员给您留言！'
                }).then(() => {
                    this.$router.push({path: '/AfterSale'})
                });
            })
        },

        // 删除图片
        delete_img() {
            this.imageUrlList.splice(-1,1)
            if(this.imageUrlList.length != 3) {
                this.upload = true
            }
        }



    }
};
</script>

<style scoped>
.van-icon, .van-icon::before {
    display: inline-block;
}

.weui-uploader__files{list-style:none}

.weui-uploader__hd{display:-webkit-box;display:-webkit-flex;display:flex;padding-bottom:10px;-webkit-box-align:center;-webkit-align-items:center;align-items:center}

.weui-uploader__title{-webkit-box-flex:1;-webkit-flex:1;flex:1}
.weui-uploader__info{color:#b2b2b2}

.weui-uploader__bd{margin-bottom:-4px;margin-right:-9px;overflow:hidden}

.weui-uploader__input-box{float:left;position:relative;margin-right:9px;margin-bottom:9px;width:146px;height:146px;border:1px solid #d9d9d9}
.weui-uploader__input-box:after,.weui-uploader__input-box:before{content:" ";position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#d9d9d9}
.weui-uploader__input-box:before{width:4px;height:72px}
.weui-uploader__input-box:after{width:72px;height:2px}
.weui-uploader__input-box:active{border-color:#999}
.weui-uploader__input-box:active:after,
.weui-uploader__input-box:active:before{background-color:#999}

.content {
    margin: 28px;
}

.message {
    position: relative;
}

.message textarea {
    width: 97%;
    text-indent:2px;
    padding: 10px;
    resize:none;
    border: none;
    border-radius: 25px;
    color: #333333;
    font-size: 40px;
    line-height: 50px;
}

.message .txtVal {
    color:#999999;
    position: absolute;
    right: 10px;
    bottom: 10px;
}

.uploadPic {
    margin: 32px 0 30px;
}

.uploadPic span {
    font-size: 34px;
    color: #999999;
}

.preserve {
    width: 100%;
    height: 128px;
    background: #39495c;
    color: #fff;
    letter-spacing: 4px;
    font-size: 44px;
    border-radius: 25px;
    margin-top: 218px;
}

</style>



// WEBPACK FOOTER //
// src/views/LeavingMessage.vue